"use client";

import React from "react";
import {PageCompetitionBookTySchema} from "@/sanity/pages/PageCompetitionBookTyTemplate";

import Image from "next/image";
import {cn} from "@/lib/utils";
import {PortableText} from "@portabletext/react";
import {richTextComponent} from "@/sanity/sanityPortableText";
import {CTACornerButton} from "@/shadcn/ui/corner-button";
import {CTAButton} from "@/shadcn/ui/button";

import bg from "@/public/competition-book-ty/last-bg.jpg";

export default function LastSection({
  data,
  className
}: {
  data: PageCompetitionBookTySchema;
  className?: string;
}) {
  return (
    <section className={cn(
      "relative overflow-clip pt-[19rem] pb-[34rem] lg:pb-[40rem] lg:pt-[33rem] -mt-[3rem]",
      className
    )}>
      <div className="absolute top-0 h-full left-1/2 -translate-x-1/2 !w-[max(100%,200rem)] pointer-events-none">
        <div className="relative w-full h-full">
          <Image
            className="!w-full !h-full object-cover max-w-none"
            src={bg}
            alt="dubai background image"
          />
          <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-[#0A1A1D] to-transparent to-[120%]" />
        </div>
      </div>

      <div className="container flex flex-col items-center relative">
        {data?.lastText && (
          <div className="richtext prose-p:text-white/60 prose-p:font-light prose-h2:mb-[3rem] prose-h2:w-[min(125rem,100%)] prose-h2:!font-ivy prose-h2:!text-[7rem] sm:prose-h2:!text-[8rem] lg:prose-h2:!text-[12rem] prose-h2:leading-none prose-h2:italic prose-h2:gradient-title-white">
            <PortableText
              value={data.lastText}
              components={richTextComponent}
            />
          </div>
        )}

        <hr className="border-t border-t-white/20 w-[min(75rem,100%)] my-[3rem]" />

        <div className="w-full flex flex-col lg:flex-row items-center justify-center gap-[2rem]">
          {data?.lastCTA && (
            <CTACornerButton
              className="sm:min-w-[45rem] lg:min-w-[unset]"
              data={data.lastCTA}
            />
          )}

          {data?.lastCTA2 && (
            <CTAButton
              className="mx-0 w-full sm:w-auto [&_.button-icon]:!hidden [&_button]:!text-white  [&_.button]:min-h-[7rem] hover:[&_button]:!text-white [&_button]:font-geist [&_button]:!font-medium [&_button]:tracking-normal sm:min-w-[45rem] lg:min-w-[unset]"
              data={data.lastCTA2}
            />
          )}
        </div>
      </div>
    </section>
  );
}
